import { getFilterMetadata } from '../../../components/StatelessComponent/FilterChainUtils';
import type { ExperimentType } from '../../../components/StatelessComponent/SingleFilter/ExperimentFilter/ExperimentFilterType';
import type { FilterKindEnum } from '../../../domains/global-filters/model/FilterChain';
import type { LabelProps } from '../LabelFormatterType';

export function getValueLabel(value?: ExperimentType): string {
  if (!value) {
    return '';
  }
  let label = `is "`;
  if (value.selectedVariants.length > 0) {
    label += `${value.selectedVariants.join(' + ')} / `;
  }
  label += `${value.experimentId}"`;
  return label;
}

export function getLabels(
  currentValue: ExperimentType | undefined,
  filterKind: FilterKindEnum,
): LabelProps {
  const metadata = getFilterMetadata(filterKind);
  return {
    label1: metadata.filterName,
    label2: getValueLabel(currentValue),
  };
}
